import React, { useEffect, useState } from "react";
import {  Box, Checkbox, Container, Typography} from "@mui/material";
import { useTranslation } from "react-i18next";
import MUIDataTable from "mui-datatables";
import { permissionActions } from "../../../redux/features/roleBasedPermission/permissionSlice";
import CONSTANTS from "../../../constants/constants";
import Skeleton from "../../common/Skeleton";


const AdminstratorSite = (props: any) => {

    const { adminstratorSite, setAdminRoleData ,skeleton,accessToAllSeller,payload } = props;

    const[t,i18n] = useTranslation();
    const [adminFinalData, setAdminFinalData]= useState<any>([]);
    const apiData: any[][] = [];

    /**
 *
 * @description - function to make adminstrator Site JSON
 */

    useEffect(() => {
        let moduleData : {moduleId: string, key: string, name: string, panel: string, permissions: any};
        const initialState = () => {
            const mappedPermissions = adminstratorSite?.map((adminModule :any, moduleId: number) => {
                const permissions = adminModule?.permissions;

                // For storeManagement 
                if(adminModule.key == "store_management"){
                    permissions.view = 1;
                }
                if(adminModule.key === "product_management" && accessToAllSeller === 0 ){
                    permissions.view = 0;
                    permissions.download = 0;
                    permissions.execute = 0;
                }
                moduleData = {
                    moduleId: adminModule?.moduleId,
                    key: adminModule?.key,
                    ... (i18n.language == "jp" ? { name: adminModule?.nameJPN } : { name: adminModule?.name }),
                    panel: adminModule?.panel,
                    permissions: permissions
                };
                return moduleData;
            });
            setAdminFinalData(mappedPermissions);
        };
        initialState();
    }, [adminstratorSite,i18n.language]);
    

    /**
 *
 * @description - function to manage Role state when any checkbox is edit
 */
    useEffect(() => {
        const changeUserRole = () =>{
            setAdminRoleData((prevItems:any) => {
                const newItems = {...prevItems,admin:adminFinalData};
                return newItems;
            });
        };
        changeUserRole();

    }, [adminFinalData]);

    /**
 *
 * @param index - index of checkbox which is edit
 * @param field - field corresponding to that checkbox
 * @description - function to manage checkedItem state when any checkbox is edit
 */
    const handleCheckboxChange = (index:any,value:any, field:any) => {
        if( field == "execute_permission"){
            setAdminFinalData((prevItems: any) => {
                const newItems = [...prevItems];
                newItems[index].permissions.execute = newItems[index].permissions.execute ^ 1;
                newItems[index].permissions.execute ? 
                    ( newItems[index].permissions.view =1,
                    newItems[index].permissions.download =1)
                    :
                    "";
                return newItems;
            });
        }else if(field == "download_permission"){
            setAdminFinalData((prevItems:any) => {
                const newItems = [...prevItems];
                newItems[index].permissions.download = newItems[index].permissions.download ^ 1;
                newItems[index].permissions.download ? 
                    (newItems[index].permissions.view =1,
                    newItems[index].permissions.execute=0)
                    :
                    (newItems[index].permissions.execute =0,
                    newItems[index].permissions.download=0)
                ;
                return newItems;
            });
        } else{
            index == 1 ? (
                setAdminFinalData((prevItems:any) => {
                    const newItems = [...prevItems];
                    newItems[index].permissions.view = CONSTANTS.RMS_PERMISSION_VIEW;
                    return newItems;
                })
            ) : (
                setAdminFinalData((prevItems:any) => {
                    const newItems = [...prevItems];
                    newItems[index].permissions.view = newItems[index].permissions.view ^ 1;
                    newItems[index].permissions.view ? 
                        ""          
                        :
                        (newItems[index].permissions.execute =0,
                        newItems[index].permissions.download=0) 
                    ;
                    return newItems;
                })
            );           
        }
    };

    const columns = [
        {
            name: t("role_management_system.particulars"),
            options: {
                filter: false,
                sort: false,
            },
        },
        {
            name: t("role_management_system.reference_authority"),
            options: {
                filter: false,
                sort: false,
            },
        },
        {
            name: t("role_management_system.download_permission"),
            options: {
                filter: false,
                sort: false,
            },
        },
        {
            name: t("role_management_system.execute_permission"),
            options: {
                filter: false,
                sort: false,
            },
        },          
    ];
    
    /**
 *
 * @param index - index of checkbox which is edit
 * @description - function to show checkbox in table under refrence autority
 */
    const refrenceAuthorityCheckbox = (value :any,index:any) =>{       
        return(
            <>
                <Checkbox
                    checked={ value}
                    onChange={() => handleCheckboxChange(index,value, "reference_authority")}
                    disabled={ (payload.sellers.length > 0 && index===3)  ||( accessToAllSeller ===0 && index===3) }
                />
            </>
        );
    };

    /**
 *
 * @param index - index of checkbox which is edit
 * @description - function to show checkbox in table under download permission
 */
    const downloadPermissionCheckbox = (value :any,index:any) =>{
        return(
            <>
                <Checkbox
                    checked={ value}
                    onChange={() => handleCheckboxChange(index,value, "download_permission")}
                    disabled={(payload.sellers.length > 0 && index===3) ||( accessToAllSeller ===0 && index===3)}
                />
            </>
        );
    };

    /**
 *
 * @param index - index of checkbox which is edit
 * @description - function to show checkbox in table under upload permission
 */
    const uploadPermissionCheckbox = (value :any,index:any) =>{
        return(
            <>
                <Checkbox
                    checked={value}
                    onChange={() => handleCheckboxChange(index,value, "execute_permission")}
                    disabled={(payload.sellers.length > 0 && index===3) ||( accessToAllSeller ===0 && index===3)}
                />
            </>
        );
    };

    const apiTableData = () => {
        {adminFinalData?.map((item: any, index: number) => {
            apiData[index] = [];
            apiData[index].push(
                item?.name,
                refrenceAuthorityCheckbox((item?.permissions.view) == 1 ? true : false, index),
                downloadPermissionCheckbox((item?.permissions.download) == 1 ? true : false, index),
                uploadPermissionCheckbox((item?.permissions.execute) == 1 ? true : false, index)
            );
        });
        }
    };
    apiTableData();

    return (

        <>                      
            <Box className="AdministrativeSiteBox">
                <Typography className="administrativeSiteTitle">{t("role_management_system.administrator_site")} </Typography>
                {skeleton ? (
                    <Skeleton
                        varient="rectangular"
                        width={0}
                        height={60}
                        count="4"
                        my={0}
                    />
                ) : (
                    <Container className="common_table createUserRoleTable">
                        <MUIDataTable 
                            title={""}
                            columns={columns}
                            data={apiData}
                            options={{
                                pagination: false,
                                print: false,
                                download: false,
                                filter: false,
                                search: false,
                                viewColumns:false,
                                selectableRowsHideCheckboxes: true,                              
                                textLabels: {
                                    body: {
                                        noMatch: t("table_text.no_match").toString(),
                                    },
                                    viewColumns: {
                                        title: t("table_text.show_columns").toString(),
                                        titleAria: "Show/Hide Table Columns",
                                    },
                                    toolbar: {
                                        search: t("table_text.search").toString(),
                                        viewColumns: t("table_text.view_columns").toString(),
                                    },
                                },
                                searchPlaceholder: t("table_text.search_placeholder").toString(),
                                responsive: "standard",                                       
                            }}                                  
                        />
                    </Container>    
                ) }                     
            </Box>                              
                   
        </>
    );
};

export default AdminstratorSite;